var React = require('react');

function Stripes01Inline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M276.841 127.375L0 433.375H82.1592L359 127.375H276.841Z","fill":"#FED136","key":0}),React.createElement("path",{"d":"M62.6931 501.375H57.3333L426.529 91.875H431.889L62.6931 501.375Z","fill":"#08273A","key":1}),React.createElement("path",{"d":"M535.094 0L271.729 292.155H349.889L613.254 0H535.094Z","fill":"#FED136","key":2})]);
}

Stripes01Inline.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 614 502"};

module.exports = Stripes01Inline;

Stripes01Inline.default = Stripes01Inline;
